function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
import { useState, useEffect } from 'react';
var Script = /*#__PURE__*/function () {
  function Script(src) {
    var _this = this;
    _classCallCheck(this, Script);
    this.state = 'PENDING';
    this.listeners = [];
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    var load = function load() {
      _this.state = 'LOADED';
      script.removeEventListener('load', load);
      _this.emitState();
    };
    var error = function error() {
      _this.state = 'ERROR';
      script.removeEventListener('error', error);
      _this.emitState();
    };
    script.addEventListener('load', load);
    script.addEventListener('error', error);
    document.body.appendChild(script);
  }
  _createClass(Script, [{
    key: "onStateChange",
    value: function onStateChange(cb) {
      var _this2 = this;
      this.listeners.push(cb);
      return function () {
        _this2.listeners = _this2.listeners.filter(function (fn) {
          return fn !== cb;
        });
      };
    }
  }, {
    key: "emitState",
    value: function emitState() {
      var _iterator = _createForOfIteratorHelper(this.listeners),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var cb = _step.value;
          cb(this.state);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);
  return Script;
}();
var scripts = new Map();

/**
 * Hook for loading external script
 * @param {string} src - The URL of the script
 * @param {boolean} [doNotLoad=false] - If set to true the script will not be loaded
 *  This can be handy because hooks can not be called conditionally by the consumer
 */
function useScript(src) {
  var doNotLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // Keeping track of script loaded and error state
  var _useState = useState({
      loaded: false,
      error: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    // If doNotLoad we return early so the script will not be loaded
    if (doNotLoad) {
      setState({
        loaded: true,
        error: false
      });
      return;
    }

    // If scripts already includes src it means that the script was already
    // loaded by another instance of the hook, so no need to load again
    var script = scripts.get(src) || scripts.set(src, new Script(src)).get(src);
    if (script.state === 'LOADED') {
      setState({
        loaded: true,
        error: false
      });
      return;
    }
    return script.onStateChange(function (state) {
      if (state === 'ERROR') {
        scripts["delete"](src);
        setState({
          loaded: true,
          error: true
        });
      } else {
        setState({
          loaded: true,
          error: false
        });
      }
    });
  }, [src, doNotLoad]);
  return [state.loaded, state.error];
}
export default useScript;